import { Icon, type IconProps } from "@chakra-ui/react";

const BrandTickActiveIcon = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<rect
				x="0.75"
				y="0.75"
				width="22.5"
				height="22.5"
				rx="11.25"
				fill="#1B58F5"
			/>
			<rect
				x="0.75"
				y="0.75"
				width="22.5"
				height="22.5"
				rx="11.25"
				stroke="#1B58F5"
				strokeWidth="1.5"
			/>
			<circle cx="12" cy="12" r="4" fill="white" />
		</Icon>
	);
};

export default BrandTickActiveIcon;
